export default {
    manage_editFuelCard_modalTitle: "Editar Tarjeta de Combustible",
    manage_editFuelCard_typeOfAssignmentSelectLabel: "Unidad / Conductor",
    manage_editFuelCard_typeOfAssignment_unassignment: "No asignado",
    manage_editFuelCard_typeOfAssignment_unit: "Unidad",
    manage_editFuelCard_typeOfAssignment_driver: "Conductor",
    manage_editFuelCard_tankSize: "Tamaño del Tanqui (Valor en Galones)",
    manage_editFuelCard_success: "Tarjeta de Combustible fue actualizada exitosamente",
    manage_editFuelCard_tankSize_error: "El tamaño del tanque no puede ser mayor a 1000"
  };
  